import type { CanMatchFn } from '@angular/router';

import { isReservedTenantSlug } from '../constants/reserved-tenant-slugs.constants';

/** Prevents `:tenantSlug` routes from capturing fixed app paths like `/blog`. */
export const notReservedTenantSlugCanMatch: CanMatchFn = (_route, segments) => {
  const slug = segments[0]?.path ?? '';
  return !isReservedTenantSlug(slug);
};
